import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { TransactionFirestoreService } from '../../services/transaction.firestore.service';
import { TransactionActions } from './transaction.action';
import { TransactionStateModel } from './transaction.store';
import { TypesaurusCore } from 'typesaurus';
import { GridApi } from 'ag-grid-community';

@State<TransactionStateModel>({
  name: 'transactions',
  defaults: {
    transactions: [],
    doneTransactions: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
    off: new Map<string, TypesaurusCore.OffSubscriptionWithCatch>(),
  },
})
@Injectable()
export class TransactionState {
  private transactionService = inject(TransactionFirestoreService);
  private readonly grids: Map<string, GridApi> = new Map<string, GridApi>();
  // private userState = inject(TransactionState);
  // private dbUser = inject(OrmService).transactionCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(TransactionActions.AddGrid)
  addGrid(ctx: StateContext<TransactionStateModel>, { api, uGridName }: TransactionActions.AddGrid) {
    this.grids.set(uGridName, api);
  }

  @Action(TransactionActions.OnGetAllQueryTransaction)
  onGetAllQueryTransactions(
    ctx: StateContext<TransactionStateModel>,
    { request, stateSelectorName }: TransactionActions.OnGetAllQueryTransaction,
  ) {
    const offCtx = ctx.getState().off;
    const stringifiedRequest = JSON.stringify(request);
    if (!offCtx.has(stringifiedRequest)) {
      ctx.patchState({ isLoading: true });
      const off = this.transactionService.OnQueryAll(request, (data) =>
        ctx.dispatch(new TransactionActions.UpdateTransactionResult(data, stateSelectorName)),
      );
      offCtx.set(stringifiedRequest, off);
      ctx.patchState({ off: offCtx });
    }
  }

  onGetAllTransactions(
    ctx: StateContext<TransactionStateModel>,
    { stateSelectorName }: TransactionActions.OnGetAllQueryTransaction,
  ) {
    const offCtx = ctx.getState().off;
    if (!offCtx.has(stateSelectorName)) {
      ctx.patchState({ isLoading: true });
      const off = this.transactionService.OnGetAll((data) =>
        ctx.dispatch(new TransactionActions.UpdateTransactionResult(data, stateSelectorName)),
      );

      //   (datas) => {
      //   ctx.patchState({
      //     [stateSelectorName]: datas.filter((x) => Boolean(x)).map(({ data, ref }) => ({ ...data, ref })),
      //     isLoading: false,
      //   });
      // });
      offCtx.set(stateSelectorName, off);
      ctx.patchState({ off: offCtx });
    }
  }

  @Action(TransactionActions.GetAllTransaction)
  async getAllTransactions(
    ctx: StateContext<TransactionStateModel>,
    { stateSelectorName }: TransactionActions.GetAllTransaction,
  ) {
    ctx.patchState({ isLoading: true });
    const transactions = await this.transactionService.GetAll();
    ctx.patchState({
      [stateSelectorName]: transactions.filter((x) => Boolean(x)).map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(TransactionActions.UpdateTransaction)
  async updateTransactions(
    ctx: StateContext<TransactionStateModel>,
    { transactionData, ref }: TransactionActions.UpdateTransaction,
  ) {
    await this.transactionService.Update(ref, transactionData);
  }

  @Action(TransactionActions.UpdateTransactionResult)
  updateTransactionResult(
    ctx: StateContext<TransactionStateModel>,
    { data, stateSelectoreName }: TransactionActions.UpdateTransactionResult,
  ) {
    patchState<TransactionStateModel>(ctx, stateSelectoreName, data);
    // [...this.grids.values()].map(x=>x.applyTransactionAsync({update:data}))
  }

  @Action(TransactionActions.PaginateQueryTransaction)
  async queryTransactions(
    ctx: StateContext<TransactionStateModel>,
    { request, isResetAfterFilterOrSort }: TransactionActions.PaginateQueryTransaction,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(TransactionState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.transactionService.SetQuery({
      ...request,
      count: state.transactions.length,
      data: state.transactions,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.transactions.length;
      state.transactions = [];
      state.transactions.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.transactions = [];
      state.transactions.length = await this.transactionService.GetBuildedCount(runs);
    }
    if (state.transactions.length !== 0) {
      runs.push(...this.transactionService.SetLimit({ ...request, count: state.transactions.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const transactionss = await this.transactionService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        transactionss.reverse().forEach(
          ({ data, ref }, i) =>
            (state.transactions[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        transactionss.forEach(
          ({ data, ref }, i) =>
            (state.transactions[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, transactions: state.transactions });
  }

  @Action(TransactionActions.OnQueryTransaction)
  async onQueryTransactions(
    ctx: StateContext<TransactionStateModel>,
    { request, stateSelectorName, isResetAfterFilterOrSort }: TransactionActions.OnQueryTransaction,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['userId']) {
    //   (request.filterModel as FilterModel)['userId']['values'] = (request.filterModel as FilterModel)[
    //     'userId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(TransactionState.users).find((user) => user.companyName === v)?.ref
    //   );
    // }
    // if (userId) {
    //   request.filterModel = {
    //     userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.transactionService.SetQuery({
      ...request,
      count: state[stateSelectorName].length,
      data: state[stateSelectorName],
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.transactions.length;
      state[stateSelectorName] = [];
      state[stateSelectorName].length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state[stateSelectorName] = [];
      state[stateSelectorName].length = await this.transactionService.GetBuildedCount(runs);
    }
    if (state[stateSelectorName].length !== 0) {
      runs.push(...this.transactionService.SetLimit({ ...request, count: state.transactions.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const transactionss = await this.transactionService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        transactionss.reverse().forEach(
          ({ data, ref }, i) =>
            (state[stateSelectorName][i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        transactionss.forEach(
          ({ data, ref }, i) =>
            (state[stateSelectorName][i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, [stateSelectorName]: state[stateSelectorName] });
  }
  // @Action(TransactionActions.TransactionError)
  // async transactionsError(ctx: StateContext<TransactionStateModel>, { error }: TransactionActions.TransactionError) {
  //   console.error({ error });
  //   // await this.transactionService.Update(id, transactionsData);
  // }

  @Action(TransactionActions.SaveTransaction)
  saveTransaction(
    ctx: StateContext<TransactionStateModel>,
    { transactionData, ref }: TransactionActions.SaveTransaction,
  ) {
    if (ref) {
      return ref.set(transactionData);
    } else {
      return this.transactionService.Create(transactionData);
    }
  }

  @Action(TransactionActions.DeleteTransactions)
  async deletetTransactions(ctx: StateContext<TransactionStateModel>, { refs }: TransactionActions.DeleteTransactions) {
    await this.transactionService.BatchDelete(refs);
  }

  // @Action(TransactionActions.GetSumsCountOf)
  // public async getCountOf(
  //   ctx: StateContext<TransactionStateModel>,
  //   { fields, timePeriod, filterModel, userId }: TransactionActions.GetSumsCountOf
  // ) {
  //   const query = {
  //     filterModel: {},
  //     startRow: undefined,
  //     endRow: undefined,
  //     sortModel: [],
  //     data: [],
  //     count: 0,
  //   };
  //   if (timePeriod.dateFrom && timePeriod.dateTo) {
  //     (query.filterModel as any)['createdAt'] = {
  //       colId: 'createdAt',
  //       type: 'inRange',
  //       filter: timePeriod.dateFrom,
  //       filterTo: timePeriod.dateTo,
  //     };
  //   }
  //   // if (userId) {
  //   //   filterModel = { userId: { filter: this.dbUser.ref(this.dbUser.id(userId)), type: 'equals' }, ...filterModel };
  //   // }
  //   for (const fieldKey in filterModel) {
  //     (query.filterModel as any)[fieldKey] = (filterModel as any)[fieldKey];
  //   }
  //   (query.filterModel as any)['paymentResult'] = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };

  //   // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
  //   const extraQuerry = this.transactionService.SetQuery(query);
  //   const querrys: { [key: string]: { sum: number; count: number } } = {};
  //   for (const field of fields) {
  //     querrys[field.sumId] = {
  //       sum: await this.transactionService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
  //       count: await this.transactionService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
  //     };
  //   }
  //   ctx.patchState({ sums: querrys });
  // }

  @Selector()
  static transactions(state: TransactionStateModel) {
    return state.transactions;
  }
  @Selector()
  static doneTransactions(state: TransactionStateModel) {
    return state.doneTransactions;
  }
  // @Selector()
  // static transactionsCount(state: TransactionStateModel) {
  //   return state.transactions.length;
  // }

  @Selector()
  static sums(state: TransactionStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: TransactionStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static transactionState(state: TransactionStateModel) {
    return state;
  }

  @Selector()
  static transactionFilter(state: TransactionStateModel) {
    return state.filter;
  }
}
